import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { UpdateDocumentTemplate, UpdateDocumentTemplateVariables } from 'types/graphql';
import DocumentTemplateApi from '../api/DocumentTemplate.api';

/** `updateDocumentTemplate` (P7-R2): `update({ id, input })` over the unchanged `UpdateDocumentTemplate` document. */
export function useUpdateDocumentTemplate(
  options?: MutationHookOptions<UpdateDocumentTemplate, UpdateDocumentTemplateVariables>
) {
  const [mutate, { loading, error }] = useMutation<UpdateDocumentTemplate, UpdateDocumentTemplateVariables>(
    DocumentTemplateApi.UpdateDocumentTemplate,
    options
  );
  const update = useCallback(
    ({ id, input }: UpdateDocumentTemplateVariables) => mutate({ variables: { id, input } }),
    [mutate]
  );
  return { update, loading, error };
}
